export default {
  preloader: true,
  message_preloader: 'Cargando',
  params: {
    year_month: null
  },
  subscriber: {
    document: {}
  }
};



// WEBPACK FOOTER //
// ./src/modules/update_balances/state.js